export type DeleteOutcome = 'deleted' | 'sync-in-progress' | 'already-deleted' | 'failed'

const SYNC_IN_PROGRESS_TEXT = 'active job'
const ALREADY_REMOVED_TEXT = 'already been removed'

const readField = (body: unknown, field: string): unknown =>
  (body as Record<string, unknown> | null | undefined)?.[field]

const readString = (body: unknown, field: string): string => {
  const value = readField(body, field)
  return typeof value === 'string' ? value.toLowerCase() : ''
}

// Status is ignored on purpose: the same refusal ships under 400 or a typed 409 depending on backend version.
export const classifyDeleteOutcome = (status: number | undefined, body: unknown): DeleteOutcome => {
  if (status !== undefined && status >= 200 && status < 300) return 'deleted'

  const errorType = readField(body, 'error_type')
  if (errorType === 'SYNC_IN_PROGRESS') return 'sync-in-progress'
  if (errorType === 'ALREADY_REMOVED') return 'already-deleted'

  const texts = [readString(body, 'detail'), readString(body, 'message')]
  if (texts.some((text) => text.includes(SYNC_IN_PROGRESS_TEXT))) return 'sync-in-progress'
  if (texts.some((text) => text.includes(ALREADY_REMOVED_TEXT))) return 'already-deleted'

  return 'failed'
}
